import { StatusPill, type StatusTone } from "@/components/shared/status-badge";

/**
 * The draft → active → archived lifecycle shared by the library entities —
 * skills, competencies, certifications and roles.
 *
 * Each of those schemas declares its own union of the same three tokens, so
 * this takes the widened shape rather than importing one of them and implying
 * the others are that type.
 */
export type LifecycleStatus = "draft" | "active" | "archived";

const STATUS_MAP: Record<LifecycleStatus, { tone: StatusTone; label: string }> = {
  draft: { tone: "neutral", label: "Draft" },
  active: { tone: "success", label: "Active" },
  archived: { tone: "warning", label: "Archived" },
};

/**
 * There were four byte-identical copies of this, one per entity folder. The
 * read path has its own copy of the labels in `audit-resolve.ts`, which is
 * deliberate — it renders into CSV and change history and never reaches the
 * UI layer.
 */
export function LifecycleBadge({ status }: { status: LifecycleStatus }) {
  const mapped = STATUS_MAP[status];
  return <StatusPill tone={mapped.tone} label={mapped.label} />;
}
